export { default } from './LoadingSlides';
